import { z } from 'zod';
import type { TFunction } from 'i18next';
import {
  PASSWORD_WITHOUT_RU_LOWER_VALIDATION_REGEX,
  PASSWORD_WITHOUT_RU_UPPER_VALIDATION_REGEX,
  PASSWORD_WITHOUT_RU_VALIDATION_REGEX,
} from '@/shared/config';

const createPasswordResetFormSchema = (t: TFunction) => {
  const minLength = t('authPages.validation.passwordRules.minLength');
  const upperLower = t('authPages.validation.passwordRules.uppercaseLowercase');
  const digit = t('authPages.validation.passwordRules.digit');
  const allowedChars = t('authPages.validation.passwordRules.specialChars');

  const passwordSchema = z
    .string()
    .refine(val => PASSWORD_WITHOUT_RU_VALIDATION_REGEX.test(val), {
      message: allowedChars,
    })
    .min(10, { message: minLength })
    .refine(
      val =>
        PASSWORD_WITHOUT_RU_LOWER_VALIDATION_REGEX.test(val) &&
        PASSWORD_WITHOUT_RU_UPPER_VALIDATION_REGEX.test(val),
      {
        message: upperLower,
      }
    )
    .refine(val => /[0-9]/.test(val), {
      message: digit,
    });

  return z.object({
    password: passwordSchema,
  });
};

export { createPasswordResetFormSchema };
